import React, { createContext, useContext, useState, useEffect, useCallback } from 'react';
import API from '../services/api';
import { useAuth } from './AuthContext';

const EMPTY_COUNTS = { pendingRequests: 0, pendingStockIn: 0, pendingItemRequests: 0, pendingAssetNumbers: 0 };
const NotificationContext = createContext({ ...EMPTY_COUNTS, refresh: () => {} });

export const NotificationProvider = ({ children }) => {
  const { user } = useAuth();
  const [counts, setCounts] = useState(EMPTY_COUNTS);

  const fetch = useCallback(async () => {
    if (!user) return;
    try {
      const res = await API.get('/notifications');
      setCounts({
        pendingRequests: Number(res.data.pendingRequests || 0),
        pendingStockIn: Number(res.data.pendingStockIn || 0),
        pendingItemRequests: Number(res.data.pendingItemRequests || 0),
        pendingAssetNumbers: Number(res.data.pendingAssetNumbers || 0),
      });
    } catch {
      // token yo'q yoki xato — 0 qolsin
    }
  }, [user]);

  useEffect(() => {
    fetch();
    const interval = setInterval(fetch, 30000); // har 30 soniyada yangilash
    return () => clearInterval(interval);
  }, [fetch]);

  return (
    <NotificationContext.Provider value={{ ...counts, refresh: fetch }}>
      {children}
    </NotificationContext.Provider>
  );
};

export const useNotifications = () => useContext(NotificationContext);
